import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, TextField, Button, Grid, Alert } from "@mui/material";
import { defaultStyle } from "components/Modals";
import { createPortfolio } from "api/resources/portfolios";
import { FormErrorProps } from "api/models/FormErrorProps";
import { ProtectedPaths } from "routes";

interface NewPortfolioModalProps {
  dispatch: any;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const NewPortfolioModal = ({
  dispatch,
  setOpenModal,
}: NewPortfolioModalProps) => {
  const [formErrors, setFormErrors] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const postData = {
      name: data.get("name"),
    };

    createPortfolio(postData)
      .then((response) => {
        setOpenModal(false);
        dispatch();
        navigate(`/${ProtectedPaths.Portfolios}/${response.data.id}`);
      })
      .catch((error) => {
        console.error(error);
        setFormErrors(error.response.data.errors);
      });
  };

  return (
    <Box sx={defaultStyle}>
      <Typography id="modal-modal-title" variant="h5" component="h5">
        Add a new portfolio
      </Typography>
      <Box component="form" onSubmit={handleSubmit} noValidate>
        <Grid container spacing={2} sx={{ mt: "1rem", mb: "2rem" }}>
          <Grid item sm={12}>
            <TextField
              id="name"
              name="name"
              label="Name"
              size="small"
              required
              sx={{ width: "100%" }}
            />
          </Grid>
          {formErrors && (
            <Grid item sm={12}>
              {formErrors.map(({ message }: FormErrorProps) => (
                <Alert variant="filled" severity="error" sx={{ mb: "0.4rem" }}>
                  {message}
                </Alert>
              ))}
            </Grid>
          )}
          <Grid item sm={12} sx={{ mt: "1rem" }}>
            <Button variant="contained" type="submit">
              Add portfolio
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default NewPortfolioModal;
